import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

import OptionTbl from './Table';
import { getLotSize } from '../../services/utilities/lotSize';

import { 
  callGreekHeaders, 
  callHeaders, 
  putGreekHeaders, 
  putHeaders 
} from "./OptionsFormatter";

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' 
    ? 'rgba(10, 25, 41, 0.8)' 
    : 'rgba(255,255,255,0.9)',
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.mode === 'dark' 
    ? 'rgba(255,255,255,0.12)' 
    : theme.palette.divider}`,
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  height: '100%',
  minHeight: 0,
  position: 'relative',
  overflow: 'hidden'
}));

const TableBox = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  touchAction: 'auto',
  overflow: 'hidden'
}));

export default function CallPutInstruments({
  row,
  underlyingToken,
  exchange,
  instrument,
  underlineTradingSymbol,
  underlyingLtp,
  selectedColumns
}) {
  console.log("instrument", instrument);
  const isInstrumentIndex = instrument?.is_index || instrument?.index === true || instrument?.series === "INDICES";

  const processedStrikes = React.useMemo(() => {
    if (!row?.strikes || !Array.isArray(row.strikes)) {
      return [];
    }

    return row.strikes.map(strike => ({
      strike_price: strike.strike_price,
      call_option: {
        ...strike.call_option,
        exchange: strike.call_option?.exchange,
        token: strike.call_option?.token,
        lotsize: getLotSize(instrument),
        tick_size: instrument?.tick_size,
        execution: strike.call_option?.execution || "REGULAR",
        tradable: isInstrumentIndex ? true : instrument?.tradable
      },
      put_option: {
        ...strike.put_option,
        exchange: strike.put_option?.exchange,
        token: strike.put_option?.token,
        lotsize: getLotSize(instrument),
        tick_size: instrument?.tick_size,
        execution: strike.put_option?.execution || "REGULAR",
        tradable: isInstrumentIndex ? true : instrument?.tradable
      }
    }));
  }, [row?.strikes, exchange, instrument, isInstrumentIndex]);

  return (
    <StyledBox>
      <TableBox>
        <OptionTbl
          underlyingToken={underlyingToken}
          arrRows={processedStrikes}
          callHeaders={callGreekHeaders}
          putHeaders={putGreekHeaders} 
          exchange={exchange}
          underlyingLtp={underlyingLtp}
          selectedColumns={selectedColumns}
        />
      </TableBox>
    </StyledBox>
  );
} 